var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.088588 0.215749L0.146448 0.146509C0.320008 -0.0270611 0.589438 -0.0463409 0.784308 0.088649L0.853548 0.146509L6 5.29306L11.1464 0.146509C11.32 -0.0270611 11.5894 -0.0463409 11.7843 0.088649L11.8536 0.146509C12.0271 0.320069 12.0464 0.589499 11.9114 0.784369L11.8536 0.853609L6.707 6.00006L11.8536 11.1465C12.0271 11.3201 12.0464 11.5895 11.9114 11.7844L11.8536 11.8537C11.68 12.0272 11.4106 12.0465 11.2157 11.9115L11.1464 11.8537L6 6.70706L0.853548 11.8537C0.679988 12.0272 0.410558 12.0465 0.215688 11.9115L0.146448 11.8537C-0.0271221 11.6801 -0.046402 11.4107 0.088588 11.2158L0.146448 11.1465L5.293 6.00006L0.146448 0.853609C-0.0271221 0.680049 -0.046402 0.410619 0.088588 0.215749L0.146448 0.146509L0.088588 0.215749Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ea009c1c3d32318f8818c1b997b6861c.svg";
export { ForwardRef as ReactComponent };